import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import rootReducer from "./reducers/rootReducer";

export default function configureStore(state = {}) {
  let middleware = [thunk];
  if (process.env.NODE_ENV === "development") {
    middleware.push(logger);
  }

  return createStore(rootReducer, applyMiddleware(...middleware));
}
